import Header47 from './Header47'
export default Header47
